import { render, staticRenderFns } from "./archived-mailings-stats-general.vue?vue&type=template&id=305e6bfa&"
import script from "./archived-mailings-stats-general.vue?vue&type=script&lang=js&"
export * from "./archived-mailings-stats-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports